import {
  DRILLS_SET_BREAKDOWN_DATA,
  DRILLS_SET_COMPARE_DATA,
  DRILLS_SET_DATES_PER_DRILL,
  DRILLS_SET_DRILLS,
  DRILLS_SET_FILTER,
  DRILLS_SET_LOADING,
} from "../actions/drills.actions";
import { INITIALIZE_STORE } from "../actions/manager.actions";

const initialState = {
  filter: {
    drill: undefined,
    date: undefined,
    position: undefined,
  },
  drills: [],
  breakdownData: [],
  compareData: null,
  dates: [],
  loading: false,
};

export const drillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DRILLS_SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case DRILLS_SET_FILTER:
      return {
        ...state,
        filter: { ...state.filter, ...action.payload },
      };
    case DRILLS_SET_DRILLS:
      return {
        ...state,
        drills: action.payload,
      };
    case DRILLS_SET_DATES_PER_DRILL:
      return {
        ...state,
        dates: action.payload,
      };
    case DRILLS_SET_BREAKDOWN_DATA:
      return {
        ...state,
        breakdownData: action.payload,
      };
    case DRILLS_SET_COMPARE_DATA:
      return {
        ...state,
        compareData: action.payload,
      };
    case INITIALIZE_STORE:
      return initialState;
    default:
      return state;
  }
};
